module.exports = __webpack_public_path__ + "static/logo-aeaa28ac2831cfe05e8c7411d77aa3e3.gif";